// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Platform resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient } from '../http.js';

export class PlatformClient {
  constructor(private readonly http: HttpClient) {}

  /** Nav entries for live-authored pages the caller is entitled to see. Only active, checksum-verified, still-valid pages for the requested shell are returned. */
  async listRuntimeNav(options?: { app?: string | undefined }): Promise<{ entries: Record<string, unknown>[] }> {
    return this.http.get<{ entries: Record<string, unknown>[] }>('/v1/platform/manifests/nav', options);
  }

  /** Page manifests for live-authored pages the caller is entitled to see, in the AppPage spec shape the shell renders directly. */
  async listRuntimePageManifests(options?: { app?: string | undefined }): Promise<{ pages: Record<string, unknown>[] }> {
    return this.http.get<{ pages: Record<string, unknown>[] }>('/v1/platform/manifests/pages', options);
  }

  /** One live-authored page manifest by name. A page the caller may not see answers 404, not 403, so a guarded page is not discoverable by probing. */
  async getRuntimePageManifest(id: string): Promise<{ id: string; path: string; label: string; contentType: string; appPageSpec: Record<string, unknown> }> {
    return this.http.get<{ id: string; path: string; label: string; contentType: string; appPageSpec: Record<string, unknown> }>(`/v1/platform/manifests/pages/${id}`);
  }

  /** Runtime dashboard manifests. Dashboards are not runtime-authorable in v1 (their widget/query shapes are outside the §3 closed vocabulary), so this answers an empty list rather than 404ing the shell boot fetch. */
  async listRuntimeDashboards(): Promise<{ dashboards: Record<string, unknown>[] }> {
    return this.http.get<{ dashboards: Record<string, unknown>[] }>('/v1/platform/manifests/dashboards');
  }
}
